import { inject, signal, computed, Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class SecurityService {
  private http = inject(HttpClient);

  private readonly apiUrl = `${environment.apiBaseUrl}/Roles`;

  private userFunctionsSignal = signal<number[]|null>(null);
  readonly userFunctions = computed(() => this.userFunctionsSignal());

  loadUserFunctionsAsync(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.http.get<number[]>(`${this.apiUrl}/getUsuarioFunciones`)
        .subscribe({
          next: (functions) => {
            this.userFunctionsSignal.set(functions);
            resolve();
          },
          error: (err) => {
            console.error('Error al obtener las funciones del usuario');
            reject(err);
          }
        });
    });
  }

  getUserFunctions(): number[]|null {
    return this.userFunctions();
    //return  [10, 11, 12, 20, 21, 22, 23, 24];
  }
}
